// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type QueryExplainQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  explainId: Types.Scalars["ID"]["input"];
}>;

export type QueryExplainQuery = {
  __typename?: "GraphqlQuery";
  getQueryExplain?: {
    __typename?: "QueryExplain";
    id: string;
    humanId: string;
    fingerprint: string;
    seenAt: number;
    totalCost?: number | null;
    totalBlkReadTime?: number | null;
    totalSharedBlksRead?: number | null;
    advisorInsights?: any | null;
    format: string;
    outputText?: string | null;
    annotatedJson?: any | null;
    source: string;
    error?: string | null;
    query: { __typename?: "Query"; id: string; truncatedQuery: string };
    querySample?: {
      __typename?: "QuerySample";
      id: string;
      occurredAt: number;
      queryText: string;
      runtimeMs: number;
      parameters?: Array<string | null> | null;
      queryTagset?: {
        __typename?: "QueryTagset";
        id: string;
        commentData: any;
      } | null;
    } | null;
    postgresRole: { __typename?: "PostgresRole"; id: string; name: string };
  } | null;
};

export const QueryExplainDocument = gql`
  query QueryExplain($databaseId: ID!, $explainId: ID!) {
    getQueryExplain(databaseId: $databaseId, explainId: $explainId) {
      id
      humanId
      fingerprint
      seenAt
      totalCost
      totalBlkReadTime
      totalSharedBlksRead
      query {
        id
        truncatedQuery
      }
      querySample {
        id
        occurredAt
        queryText
        runtimeMs
        queryTagset {
          id
          commentData
        }
        parameters
      }
      postgresRole {
        id
        name
      }
      advisorInsights
      format
      outputText
      annotatedJson
      source
      error
    }
  }
`;

/**
 * __useQueryExplainQuery__
 *
 * To run a query within a React component, call `useQueryExplainQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryExplainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryExplainQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      explainId: // value for 'explainId'
 *   },
 * });
 */
export function useQueryExplainQuery(
  baseOptions: Apollo.QueryHookOptions<
    QueryExplainQuery,
    QueryExplainQueryVariables
  > &
    (
      | { variables: QueryExplainQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<QueryExplainQuery, QueryExplainQueryVariables>(
    QueryExplainDocument,
    options,
  );
}
export function useQueryExplainLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryExplainQuery,
    QueryExplainQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<QueryExplainQuery, QueryExplainQueryVariables>(
    QueryExplainDocument,
    options,
  );
}
// @ts-ignore
export function useQueryExplainSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    QueryExplainQuery,
    QueryExplainQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<QueryExplainQuery, QueryExplainQueryVariables>;
export function useQueryExplainSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryExplainQuery,
        QueryExplainQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  QueryExplainQuery | undefined,
  QueryExplainQueryVariables
>;
export function useQueryExplainSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryExplainQuery,
        QueryExplainQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<QueryExplainQuery, QueryExplainQueryVariables>(
    QueryExplainDocument,
    options,
  );
}
export type QueryExplainQueryHookResult = ReturnType<
  typeof useQueryExplainQuery
>;
export type QueryExplainLazyQueryHookResult = ReturnType<
  typeof useQueryExplainLazyQuery
>;
export type QueryExplainSuspenseQueryHookResult = ReturnType<
  typeof useQueryExplainSuspenseQuery
>;
export type QueryExplainQueryResult = Apollo.QueryResult<
  QueryExplainQuery,
  QueryExplainQueryVariables
>;
